import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.background};
  width: 100%;
  height: 100%;
  padding: 25px 10px;
  gap: 15px;
  padding: 15px;
`;

export const TitleBar = styled.h3`
  font-size: 22px;
  margin: 0;
  color: ${(props) => props.theme.colors.text};
`;

export const Info = styled.p`
  display: flex;
  flex-direction: ${(props) => props.defaultValue};
  gap: 15px;
  font-size: 12px;
  align-items: center;
  color: ${(props) => props.theme.colors.text};
`;

export const Products = styled.div`
  display: flex;
  flex-direction: column;
`;

interface InputProps {
  active?: boolean;
}

export const Input = styled.input<InputProps>`
  font-size: 12px;
  font-weight: 600;
  height: 35px;
  padding: 8px 10px;
  border-radius: 5px;
  background-color: white;
  color: ${(props) =>
    props.active ? props.theme.colors.primary : props.theme.colors.text};
  align-self: flex-start;
  border: 1px solid
    ${(props) =>
      props.active
        ? props.theme.colors.primary
        : props.theme.colors.inputBorder};
  outline: none;
  width: ${(props) => `${props.value}`.length}ch;
  min-width: 160px;

  &:hover,
  &:focus {
    color: ${(props) => props.theme.colors.text};
    border: 1px solid ${(props) => props.theme.colors.primary};
  }
`;
